import ReviewAndSubmit from "./ReviewAndSubmit";

import { useGetProspectDataQuery } from "types/generated/operations";

import { getProspectUuid } from "utils/idHelpers";

import Loader from "uicomponents/Loader";
import Error from "uicomponents/Error";

interface IReviewAndSubmitProps {
  setNextStep: () => void;
  setPreviousStep: () => void;
  setActiveStepIndex: (index: number) => void;
}

const ReviewAndSubmitModel = ({ ...props }: IReviewAndSubmitProps) => {
  const { data, error, loading } = useGetProspectDataQuery({
    variables: { uuid: getProspectUuid() },
    fetchPolicy: "no-cache",
  });

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <Error />;
  }

  return (
    <ReviewAndSubmit
      setNextStep={props.setNextStep}
      setPreviousStep={props.setPreviousStep}
      setActiveStepIndex={props.setActiveStepIndex}
      data={data?.prospect}
    />
  );
};

export default ReviewAndSubmitModel;
